import API from "api/client";
import { envConfig } from "config";
import { toObject } from "@civicscience/chops";

const { questionFeedsAPI } = envConfig;

/**
 * @typedef { import('types').FeedNotification } FeedNotification
 * @typedef { import('types').QuestionFeedCreate } QuestionFeedCreate
 * @typedef { import('types').QuestionFeedUpdate } QuestionFeedUpdate
 * @typedef { import('types').QuestionFeed } QuestionFeed
 */

/**
 * @param {QuestionFeedCreate} req
 * @returns {Promise<QuestionFeed>}
 */
const createQuestionFeed = (req) => {
  return API.post(`${questionFeedsAPI}`, req).then((res) => res.data);
};

/**
 * @param {int} id
 * @returns {Promise<void>}
 */
const deleteQuestionFeed = (id) => {
  return API.delete(`${questionFeedsAPI}${id}`).then((res) => res.data);
};

/**
 * @param id {string|int}
 * @returns {Promise<{}>}
 */
const getQuestionFeed = (id) => {
  return API.get(`${questionFeedsAPI}${id}`).then((res) => res.data);
};

/**
 * @param options {object}
 * @param options.query {string}
 * @param options.orderBy {string}
 * @param options.order {string}
 * @param options.page {int}
 * @param options.size {int}
 * @returns {Promise<[]>}
 */
const getQuestionFeeds = (options) => {
  const { query, orderBy, order, page = 1, size = 10 } = toObject(options);
  return API.get(`${questionFeedsAPI}`, {
    params: { query: query, orderBy, order, page, size },
  }).then((res) => res.data);
};

/**
 * @param {number} feedId The ID of the question feed being requested.
 * @returns {Promise<FeedNotification[]>}
 */
const getQuestionFeedNotifications = (feedId) => {
  return API.get(`${questionFeedsAPI}${feedId}/notifications`).then((res) => res.data);
};

const getQuestionFeedsForDeployment = () => {
  return API.get(`${questionFeedsAPI}deployment`).then((res) => res.data);
};

/**
 * Updates the question feed with the given ID.
 * @param {QuestionFeedUpdate} req
 * @returns {Promise<QuestionFeed>}
 */
const updateQuestionFeed = ({ questionFeedId, ...req }) => {
  return API.put(`${questionFeedsAPI}${questionFeedId}`, req).then((res) => res.data);
};

/**
 * @param {number} id
 * @param {FeedNotification[]} notifications
 * @returns {Promise<FeedNotification[]>}
 */
const updateQuestionFeedNotifications = (id, notifications) => {
  return API.put(`${questionFeedsAPI}${id}/notifications`, notifications).then((res) => res.data);
};

export default {
  create: createQuestionFeed,
  delete: deleteQuestionFeed,
  get: getQuestionFeed,
  list: getQuestionFeeds,
  listNotifications: getQuestionFeedNotifications,
  listForDeployment: getQuestionFeedsForDeployment,
  update: updateQuestionFeed,
  updateNotifications: updateQuestionFeedNotifications,
};
